/* eslint-disable no-param-reassign */
export const statefor = (component) => (newState) => {
    if (newState) {
        const keys = Object.keys(newState)
        keys.forEach((key) => {
            component.$data[key] = newState[key]
        })
    }
    return { ...component.$data, ...component.$props }
}

export const getstate = (component) => ({ ...component.$data, ...component.$props })
